import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';

const commands = {
    h: ['Home', '/'],
    p: ['Publications', '/Publications'],
    g: ['GitHub projects', '/GitHub'],
    o: ['PodBox', '/PodBox'],
    a: ['Project archive', '/Archive'],
    b: ['About', '/About'],
    c: ['Contact', '/Contact']
};

const EmacsNavigation = () => {
    const history = useHistory();
    const [pending, setPending] = useState(false);
    const [helpOpen, setHelpOpen] = useState(false);
    const timer = useRef(null);
    const pendingRef = useRef(false);

    useEffect(() => {
        const clearChord = () => {
            pendingRef.current = false;
            setPending(false);
            window.clearTimeout(timer.current);
        };

        const handleHelpRequest = () => setHelpOpen((open) => !open);
        const handleKeyDown = (event) => {
            const tag = event.target && event.target.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || event.target.isContentEditable) return;

            if (event.key === 'Escape') {
                clearChord();
                setHelpOpen(false);
                return;
            }

            if (event.ctrlKey && event.key.toLowerCase() === 'h') {
                event.preventDefault();
                clearChord();
                setHelpOpen((open) => !open);
                return;
            }

            if (event.ctrlKey && event.key.toLowerCase() === 'x') {
                event.preventDefault();
                pendingRef.current = true;
                setPending(true);
                window.clearTimeout(timer.current);
                timer.current = window.setTimeout(clearChord, 2400);
                return;
            }

            if (pendingRef.current) {
                const command = commands[event.key.toLowerCase()];
                event.preventDefault();
                clearChord();
                if (command) {
                    history.push(command[1]);
                    window.scrollTo({top: 0, behavior: 'auto'});
                }
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('emacs-help', handleHelpRequest);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('emacs-help', handleHelpRequest);
            window.clearTimeout(timer.current);
        };
    }, [history]);

    return (
        <>
            {pending && <div className="chord-indicator" role="status"><span>C-x</span> waiting for key…</div>}
            {helpOpen &&
                <aside className="emacs-help" aria-label="Emacs navigation shortcuts">
                    <div><strong>*Key Bindings*</strong><button onClick={() => setHelpOpen(false)} aria-label="Close shortcut help">×</button></div>
                    <p><kbd>C-h</kbd> toggle this help</p>
                    {Object.entries(commands).map(([key, command]) =>
                        <p key={key}><kbd>C-x {key}</kbd><span>{command[0]}</span></p>
                    )}
                    <small>Press <kbd>ESC</kbd> to quit</small>
                </aside>
            }
        </>
    );
};

export default EmacsNavigation;
